"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailInfo = exports.deviceBasicInfo = exports.deviceNullTextList = void 0;
const judge = (flag, trueText, falseText) => {
    return flag ? trueText : falseText;
};
exports.deviceNullTextList = [
    {
        label: "溯源器件SN",
        judgement: "",
        value: "数据缺失",
    },
    {
        label: "溯源器件物料编码",
        judgement: "materialName",
        value: (flag) => {
            return judge(flag, "SIM卡无物料编码", "数据缺失");
        },
    },
    {
        label: "溯源器件物料名称",
        judgement: "",
        value: "数据缺失",
    },
    {
        label: "溯源器件数量",
        judgement: "",
        value: "数据缺失",
    },
    {
        label: "采购质保期",
        judgement: "",
        value: "数据缺失",
    },
    {
        label: "产品sn码",
        judgement: "",
        value: "",
    },
    {
        label: "整桩的产品编码",
        judgement: "",
        value: "数据缺失",
    },
    {
        label: "整桩的产品名称",
        judgement: "",
        value: "数据缺失",
    },
    {
        label: "制令单",
        judgement: "",
        value: "",
    },
    {
        label: "整桩生产线体",
        judgement: "",
        value: "数据缺失",
    },
];
exports.deviceBasicInfo = [
    {
        label: "所属桩",
        key: "zhengzhuangdechanpinmingcheng",
        span: 2,
    },
    {
        label: "桩SN",
        key: "chengpinsnma",
        isClick: true,
    },
    {
        label: "桩编码",
        key: "zhengzhuangdechanpinbianma",
    },
    {
        label: "制令单",
        key: "zhilingdan",
    },
    {
        label: "生产线体",
        key: "zhengzhuangshengchanxianti",
    },
];
exports.detailInfo = [
    {
        key: "gongyingshang",
        label: "供应商编号：",
    },
    {
        key: "lailiaopici",
        label: "供应商批次：",
    },
    {
        key: "caigouzhibaoqi",
        label: "质保期结束时间：",
    },
    {
        key: "genghuanjiluList",
        label: "更换记录：",
        isMultiple: true,
    },
];
